/**
 * The two supported ways to connect GitHub. GITHUB_APP is the direct integration (ADR 0002);
 * MERGE_DEV is the legacy PAT-through-Merge path that existing customers stay on until they
 * re-onboard onto the App.
 *
 * Lives here rather than beside the slide that renders the choice: the Data Sources rows decide the
 * method too, and a hook reaching into the connect-provider organisms for it would close a cycle
 * back through `shared/hooks`.
 */
export enum GitHubConnectMethod {
  GITHUB_APP = 'GITHUB_APP',
  MERGE_DEV = 'MERGE_DEV',
}
